import { dataReportSettings } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportSettings = /*#__PURE__*/createIcon(dataReportSettings)
export default IconReportSettings
